<script>
    import CardCinema from "../components/CardCinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /**
 *
 */
    let {
        contextDresonRule,
        timelineEntryId,
        index,
        view,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        featureIndex,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let recommendations = $state(),
        headline = $state(),
        additionalClickTracking = $state(),
        tracking = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    const site = "reco_brand";

    let hasElevationLevel = $state(false);

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const indexParam = index ? `&index=${index}` : "";
        const viewParam = view ? `&view=${view}` : "";
        const timelineEntryIdParam = timelineEntryId ? `&timelineEntryId=${timelineEntryId}` : "";
        const parameters = `${indexParam}${timelineEntryIdParam}${viewParam}`;
        const res = await ajaxFetch(
            `/reco-core/recommendations/brand?encodedDresonRule=${contextDresonRule}${parameters}`
        );
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            recommendations,
            headline,
            featuresState,
            additionalClickTracking,
            tracking,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        hasElevationLevel = ![null, ""].includes(headline);
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_card_cinema_wrapper">
        <CardCinema
            {headline}
            {recommendations}
            {performance}
            {cinemaInjectionContainerWidth}
            additionalCinemaClickTracking={additionalClickTracking}
            {featuresState}
            {featureIndex}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            {tracking}
            personalisedUser={hasPersonalisedRecommendations}
            {site}
            {hasElevationLevel}
        />
    </div>
{/if}

<style lang="scss">
    .reco_card_cinema_wrapper {
        max-height: 672px;
        position: relative;
    }
</style>
